import React, { useEffect, useState, useCallback } from 'react';
import Swal from 'sweetalert2';
import { api } from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import { statusPush, ativarPush, desativarPush, pushSuportado } from '../services/push';
import EmptyState from '../components/EmptyState';

function formatarData(d) {
  if (!d) return '';
  return new Date(d).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
}

export default function Home() {
  const { user } = useAuth();
  const [push, setPush] = useState({ suportado: true, ativo: false, permissao: 'default' });
  const [carregandoPush, setCarregandoPush] = useState(false);
  const [notificacoes, setNotificacoes] = useState([]);
  const [carregandoNotif, setCarregandoNotif] = useState(true);

  const recarregarPush = useCallback(async () => {
    const s = await statusPush();
    setPush(s);
  }, []);

  useEffect(() => {
    recarregarPush();
  }, [recarregarPush]);

  useEffect(() => {
    let cancelado = false;
    api.get('/notifications/minhas?limit=15')
      .then(({ data }) => { if (!cancelado) setNotificacoes(data); })
      .catch(() => {})
      .finally(() => { if (!cancelado) setCarregandoNotif(false); });
    return () => { cancelado = true; };
  }, []);

  const ativar = async () => {
    setCarregandoPush(true);
    try {
      await ativarPush();
      await recarregarPush();
      Swal.fire({ icon: 'success', title: 'Notificações ativadas!', text: 'Você receberá avisos da Centrão neste dispositivo.', confirmButtonColor: '#2e9846' });
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Não foi possível ativar', text: err.message, confirmButtonColor: '#2e9846' });
    } finally {
      setCarregandoPush(false);
    }
  };

  const desativar = async () => {
    setCarregandoPush(true);
    try {
      await desativarPush();
      await recarregarPush();
    } finally {
      setCarregandoPush(false);
    }
  };

  return (
    <>
      <div className="hero-cli">
        <h1>Olá, {user?.nome?.split(' ')[0] || 'cliente'} 👋</h1>
        <p>Bem-vindo ao portal da Centrão. Aqui você fica por dentro das novidades.</p>
        {pushSuportado() && (
          <span className={'chip-push-cli' + (push.ativo ? ' ativo' : '')}>
            <i className={'bi ' + (push.ativo ? 'bi-bell-fill' : 'bi-bell-slash')}></i>
            {push.ativo ? 'Notificações ativas' : 'Notificações desativadas'}
          </span>
        )}
      </div>

      <div className="card-cli">
        <h2 style={{ marginTop: 0, color: 'var(--verde-escuro)', fontSize: '1.1rem' }}>
          <i className="bi bi-megaphone-fill" style={{ color: 'var(--laranja)', marginRight: 8 }}></i>
          Ativar notificações
        </h2>
        {!pushSuportado() ? (
          <p style={{ color: 'var(--texto-suave)' }}>
            Este navegador não suporta notificações push. Tente acessar pelo Chrome ou Firefox.
          </p>
        ) : push.ativo ? (
          <>
            <p>Notificações ativas neste dispositivo. Você receberá avisos da Centrão mesmo com o portal fechado.</p>
            <button className="btn-ghost-cli" onClick={desativar} disabled={carregandoPush}>
              {carregandoPush ? 'Desativando…' : 'Desativar neste dispositivo'}
            </button>
          </>
        ) : (
          <>
            <p>Ative para receber avisos, promoções e novidades da Centrão direto no seu celular.</p>
            <button className="btn-laranja-cli" onClick={ativar} disabled={carregandoPush}>
              <i className="bi bi-bell-fill"></i>
              {carregandoPush ? 'Ativando…' : 'Ativar notificações'}
            </button>
          </>
        )}
      </div>

      <div className="card-cli">
        <h2 style={{ marginTop: 0, color: 'var(--verde-escuro)', fontSize: '1.1rem' }}>
          <i className="bi bi-clock-history" style={{ color: 'var(--laranja)', marginRight: 8 }}></i>
          Últimas notificações
        </h2>
        {carregandoNotif ? (
          <p style={{ color: 'var(--texto-suave)' }}>Carregando…</p>
        ) : notificacoes.length === 0 ? (
          <EmptyState
            icon="bi-inbox"
            titulo="Nenhuma notificação por aqui"
            mensagem="Quando a Centrão enviar avisos, eles aparecem nesta lista."
          />
        ) : (
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {notificacoes.map((n) => (
              <li key={n.id} style={{ padding: '12px 0', borderBottom: '1px solid var(--cinza-borda)' }}>
                <div style={{ fontWeight: 700, color: 'var(--verde-escuro)' }}>{n.titulo}</div>
                <div style={{ fontSize: '0.92rem', margin: '4px 0' }}>{n.corpo}</div>
                <div style={{ fontSize: '0.78rem', color: 'var(--texto-suave)' }}>
                  {formatarData(n.enviado_em)}
                  {n.destinatario_tipo === 'broadcast' && <span className="tag-cli cinza" style={{ marginLeft: 8 }}>Para todos</span>}
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>

      <div className="card-cli">
        <h2 style={{ marginTop: 0, color: 'var(--verde-escuro)', fontSize: '1.1rem' }}>
          <i className="bi bi-telephone-fill" style={{ color: 'var(--laranja)', marginRight: 8 }}></i>
          Atendimento Centrão
        </h2>
        <p style={{ marginBottom: 4 }}>
          <strong>Telefone:</strong> (XX) XXXX-XXXX
        </p>
        <p style={{ marginBottom: 0, color: 'var(--texto-suave)' }}>
          Atendimento de segunda a sábado, 7h às 18h.
        </p>
      </div>
    </>
  );
}
